(function () {
  const rowSelector = '.cp-variant-swatches';
  const swatchSelector = '.cp-swatch';
  const overflowClass = 'has-overflow';
  let resizeObserver = null;

  function getRows(root) {
    if (!root || !root.querySelectorAll) return [];
    return Array.from(root.querySelectorAll(rowSelector));
  }

  function getMarker(row) {
    let marker = row.querySelector('.cp-variant-swatches__overflow');

    if (!marker) {
      marker = document.createElement('span');
      marker.className = 'cp-variant-swatches__overflow';
      marker.setAttribute('aria-hidden', 'true');
      marker.hidden = true;
      marker.textContent = '...';
      row.appendChild(marker);
    }

    return marker;
  }

  function getSwatches(row) {
    return Array.from(row.querySelectorAll(swatchSelector));
  }

  function restoreSwatches(swatches) {
    swatches.forEach(function (swatch) {
      swatch.hidden = false;
    });
  }
  function getCardFromSwatch(swatch) {
    return swatch ? swatch.closest('.cp-product-card') : null;
  }
  function getVariants(card) {
    if (!card || !card.dataset.productVariants) return [];

    try {
      return JSON.parse(card.dataset.productVariants);
    } catch (error) {
      console.error('Unable to parse CP product variants.', error);
      return [];
    }
  }
  function updateVariantId(card, variantId) {
    const hiddenInput = card ? card.querySelector('input[name="id"]') : null;

    if (hiddenInput) {
      hiddenInput.value = variantId;
    }
  }
  function updateImage(card, variant) {
    const primaryImage = card ? card.querySelector('.cp-primary-image') : null;

    if (!primaryImage) return;

    if (variant && variant.featured_image && variant.featured_image.src) {
      primaryImage.src = variant.featured_image.src;
      return;
    }

    const originalSrc = primaryImage.dataset.originalSrc || primaryImage.src;
    primaryImage.dataset.originalSrc = originalSrc;
    primaryImage.src = originalSrc;
  }
  function updatePrice(card, variant) {
    if (!card || !variant || !window.Shopify || typeof window.Shopify.formatMoney !== 'function') return;

    const priceEl = card.querySelector('.cp-product-price .price');
    const comparePriceEl = card.querySelector('.cp-product-price .compare-at-price');
    const moneyFormat = (window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.money_format) || '${{amount}}';
    const storefrontMoneyFormatter =
      window.PXUTheme &&
      window.PXUTheme.currency &&
      typeof window.PXUTheme.currency.formatMoneyNoTrailingZeros === 'function'
        ? window.PXUTheme.currency.formatMoneyNoTrailingZeros
        : Shopify.formatMoney;

    if (priceEl) {
      priceEl.innerHTML = storefrontMoneyFormatter(variant.price, moneyFormat);
    }

    if (!comparePriceEl) return;

    if (variant.compare_at_price > variant.price) {
      comparePriceEl.innerHTML = storefrontMoneyFormatter(variant.compare_at_price, moneyFormat);
      comparePriceEl.style.display = 'inline';
    } else {
      comparePriceEl.style.display = 'none';
    }
  }
  function updateAddToCartButton(card, variant) {
    const atcButton = card ? card.querySelector('.cp-add-to-cart-btn') : null;
    const atcButtonText = atcButton ? atcButton.querySelector('.btn-text') : null;
    const translation = window.PXUTheme && window.PXUTheme.translation ? window.PXUTheme.translation : {};

    if (!atcButton || !atcButtonText || !variant) return;

    if (variant.available) {
      atcButton.disabled = false;
      atcButtonText.textContent = translation.add_to_cart || 'Add to cart';
    } else {
      atcButton.disabled = true;
      atcButtonText.textContent = translation.sold_out_text || 'Sold out';
    }
  }
  function updateActiveSwatch(swatch) {
    const row = swatch ? swatch.parentElement : null;

    if (!row) return;

    row.querySelectorAll(swatchSelector).forEach(function (candidate) {
      candidate.classList.remove('active');
    });
    swatch.classList.add('active');
  }
  function syncCardVariant(swatch) {
    const card = getCardFromSwatch(swatch);
    const variants = getVariants(card);

    if (!card || !variants.length) return;

    const selectedValue = swatch.dataset.value;
    const selectedVariant = variants.find(function (variant) {
      return variant.option1 === selectedValue || variant.option2 === selectedValue || variant.option3 === selectedValue;
    });

    if (!selectedVariant) return;

    updateVariantId(card, selectedVariant.id);
    updateImage(card, selectedVariant);
    updatePrice(card, selectedVariant);
    updateAddToCartButton(card, selectedVariant);
    updateActiveSwatch(swatch);
  }

  function getHideCandidates(swatches) {
    const inactive = [];
    const active = [];

    swatches.forEach(function (swatch) {
      if (swatch.classList.contains('active')) {
        active.push(swatch);
      } else {
        inactive.push(swatch);
      }
    });

    return inactive.reverse().concat(active.reverse());
  }

  function updateSwatchRow(row) {
    if (!row || row.clientWidth === 0) return;

    const swatches = getSwatches(row);

    if (!swatches.length) return;

    const marker = getMarker(row);
    const hideCandidates = getHideCandidates(swatches);
    let hiddenCount = 0;

    row.classList.remove(overflowClass);
    marker.hidden = true;
    restoreSwatches(swatches);

    if (row.scrollWidth <= row.clientWidth) return;

    hideCandidates.forEach(function (swatch) {
      if (row.scrollWidth <= row.clientWidth) return;
      swatch.hidden = true;
      hiddenCount += 1;
    });

    if (hiddenCount === 0) return;

    row.classList.add(overflowClass);
    marker.hidden = false;

    hideCandidates.forEach(function (swatch) {
      if (row.scrollWidth <= row.clientWidth) return;
      if (swatch.hidden) return;
      swatch.hidden = true;
    });

    if (swatches.every(function (swatch) { return swatch.hidden; })) {
      swatches[0].hidden = false;
    }

    if (row.scrollWidth > row.clientWidth) {
      marker.hidden = true;
      row.classList.remove(overflowClass);
    }
  }

  function observeRow(row) {
    if (!row || row.dataset.cpSwatchesObserved === 'true') {
      updateSwatchRow(row);
      return;
    }

    row.dataset.cpSwatchesObserved = 'true';
    getMarker(row);
    updateSwatchRow(row);

    if (resizeObserver) {
      resizeObserver.observe(row);
    }
  }

  function init(root) {
    getRows(root).forEach(observeRow);
  }

  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        updateSwatchRow(entry.target);
      });
    });
  }

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest(swatchSelector);

    if (!swatch) return;

    syncCardVariant(swatch);

    window.requestAnimationFrame(function () {
      updateSwatchRow(swatch.closest(rowSelector));
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
